// src/components/LineChart.jsx
import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler
} from 'chart.js';

ChartJS.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler
);

const LineChart = ({ data, dataObject, tailwindWidth, tailwindHeight }) => {

	const [chartData, setChartData] = useState({
		labels: ['Tickets Abertos', 'Tickets Fechados'],
		datasets: [
			{
				label: 'Tickets Abertos',
				data: [],
				borderColor: 'rgb(59, 130, 246)', // Tailwind blue-500
				backgroundColor: 'rgba(59, 130, 246, 0.2)',
				tension: 0.1,
				fill: true,
			},
			{
				label: 'Tickets Fechados',
				data: [],
				borderColor: 'rgb(112, 121, 128)', // Tailwind blue-500
				backgroundColor: 'rgba(112, 121, 128, 0.2)',
				tension: 0.1,
				fill: true,
			},
		],
	});

	const getOptions = (_argObject) => {
		return ({
			responsive: true,
			maintainAspectRatio: false,
			plugins: {
				legend: {
					position: _argObject?.legendPosition || 'top',
					labels: { color: _argObject?.legendColor || '#374151' }
				},
				title: {
					display: true,
					text: _argObject?.title,//`Tickets Abertos por Dia (${new Date().toLocaleString('pt-BR', { month: 'long' })})`,
					color: _argObject?.color || '#1f2937',
					font: { size: _argObject?.fontSize || 18 }
				},
				tooltip: {
					mode: 'index',
					intersect: false,
				}
			},
			scales: {
				y: {
					beginAtZero: true,
					title: {
						display: true,
						text: _argObject?.labelY, //'Número de Tickets', 
						color: _argObject?.labelYColor || '#4b5563'
					},
					grid: { color: _argObject?.gridYColor || '#e5e7eb' },
					ticks: { color: _argObject?.ticksYColor || '#4b5563' }
				},
				x: {
					title: {
						display: true,
						text: _argObject?.labelX,//'Dia do Mês',
						color: _argObject?.labelXColor || '#4b5563'
					},
					grid: { display: false },
					ticks: { color: _argObject?.ticksXColor || '#4b5563' }
				},
			},
		})
	}

	useEffect(() => {
		if (Object?.keys(dataObject?.opened)?.length > 0) {
			setChartData({
				...chartData,
				labels: Object?.values(dataObject?.opened).map(el => el.day) || [],
				datasets: [
					{
						...chartData.datasets[0],
						data: Object?.values(dataObject?.opened).map(el => el.qty),
					},
					{
						...chartData.datasets[1],
						data: Object?.values(dataObject?.closed).map(el => el.qty),
					},
				],
			});

		}

	}, [dataObject])

	return (
		<div className={`bg-white p-4 sm:p-6 rounded-lg shadow-lg ${tailwindHeight} ${tailwindWidth}`}> {/* Defina uma altura ou use aspect-ratio */}
			{/* <Line data={data} options={getOptions({})} /> */}
			<Line data={chartData} options={getOptions({})} />
		</div>
	);
};

export default LineChart;